(ns common.schema.entities.value-creation.schema
  (:require
   [common.schema.schema-utils :as su]
   [common.schema.entities.related-entities :as related-entities]
   [common.value-creation-status :as value-creation-status]
   [common.schema.option-filters :as option-filters]))

(def value-creation-related-entities-attributes
  [:common/related-entities-investor
   :common/related-entities-company
   :common/related-entities-oppo
   :common/related-entities-person
   :common/related-entities-holdings])

(def related-entities
  (->> related-entities/related-entities
       (filter (fn [[related-entities-attribute _]]
                 (some #{related-entities-attribute} value-creation-related-entities-attributes)))))

(def new-value-creation
  (concat
   (su/text-simple-field :value-creation/title
                         "Title"
                         {:authorization su/access-user-user
                          :default-field-visibility :in-use-disabled})
   (su/text-multiline-field :value-creation/description-and-lessons-learned
                            "Description and lessons learned"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use-disabled})
   (su/option-field :value-creation/international-aspect
                    "International aspect"
                    {:authorization su/access-user-user
                     :default-field-visibility :not-in-use})
   (su/option-field-multi :value-creation/cross-category-theme
                          "Cross-category theme"
                          {:authorization su/access-user-user
                           :default-field-visibility :in-use-disabled})
   (su/single-ref-field :value-creation/our-manager
                        "Our manager"
                        [:entity.type/account]
                        {:authorization            su/access-user-user
                         :default-field-visibility :in-use-disabled
                         :option-filter-fn         option-filters/active-users
                         :os-filter-terms-fn       (fn [{:keys [] :as _args}]
                                                     {"extras.active-user" true})})
   (su/integer-field :value-creation/execution-year
                     "Execution year"
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use-disabled})
   (su/option-field :value-creation/our-role
                    "Our role"
                    {:authorization su/access-user-user
                     :default-field-visibility :in-use-disabled})
   (su/text-simple-field :value-creation/holding-our-managers-role
                         "Our manager's role"
                         {:authorization su/access-user-user
                          :default-field-visibility :in-use-disabled})
   (su/option-field :value-creation/results
                    "Results"
                    {:authorization su/access-user-user
                     :default-field-visibility :in-use-disabled})
   (su/option-field :value-creation/help-needed
                    "Help needed"
                    {:authorization su/access-user-user
                     :default-field-visibility :in-use-disabled})
   (su/text-simple-field :value-creation/help-needed-description
                         "Help needed description"
                         {:authorization su/access-user-user
                          :default-field-visibility :in-use-disabled})
   (su/date-field :value-creation/date-execution-date
                  "Execution date"
                  {:authorization su/access-user-user
                   :default-field-visibility :in-use-disabled})
   (su/option-field :value-creation/target
                    "Value creation target"
                    {:authorization su/access-user-user
                     :default-field-visibility :in-use-disabled})
   (su/option-field :value-creation/investor-maturity
                    "Investor maturity"
                    {:authorization su/access-user-user
                     :default-field-visibility :in-use-disabled})
   (su/keyword-field :value-creation/status
                     "Status"
                     value-creation-status/options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use-disabled})
   (su/single-ref-field :value-creation/parent-entity
                        "Parent entity"
                        [:entity.type/investor :entity.type/holding]
                        {:authorization su/access-user-user
                         :select-entity-types [:entity.type/person :entity.type/company :entity.type/holding]
                         :create-entity-types [:entity.type/person :entity.type/company]
                         :default-field-visibility :in-use-disabled})
   (su/option-field :value-creation/investor-our-managers-role
                    "Our manager's role"
                    {:authorization su/access-user-user
                     :default-field-visibility :in-use-disabled})
   (su/option-field-multi :value-creation/agm-and-advisory-boards
                          "AGM/Advisory boards"
                          {:authorization su/access-user-user
                           :default-field-visibility :in-use-disabled})
   (su/option-field-multi :value-creation/investor-categories
                          "Categories"
                          {:authorization su/access-user-user
                           :default-field-visibility :in-use-disabled})
   (su/option-field-multi :value-creation/investor-subcategories
                          "Subcategories"
                          {:authorization su/access-user-user
                           :default-field-visibility :in-use-disabled})
   (su/option-field :value-creation/holding-category
                    "Category"
                    {:authorization su/access-user-user
                     :default-field-visibility :in-use-disabled})
   (su/option-field :value-creation/holding-subcategory
                    "Subcategory"
                    {:authorization su/access-user-user
                     :default-field-visibility :in-use-disabled})
   (su/multi-ref-field :value-creation/our-managers
                       "Our managers"
                       [:entity.type/account]
                       {:authorization            su/access-user-user
                        :default-field-visibility :in-use-disabled
                        :option-filter-fn         option-filters/active-users
                        :os-filter-terms-fn       (fn [{:keys [] :as _args}]
                                                    {"extras.active-user" true})})
   related-entities))
